let id = 0;
const incrementalId = () => {
  return ++id;
};
export {
  incrementalId
};
//# sourceMappingURL=incrementalId.es.js.map
